"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.DEFAULT_COPY = void 0;
const DEFAULT_COPY = exports.DEFAULT_COPY = 'en';

/**
 * Extract translations from a keyed dictionary for a given language.
 * Returns a getter.
 *
 * @example
 * const getCopy = useCopy({
 *   copy: 'en',
 *   dictionary: {
 *     en: { label: 'english label' },
 *     fr: { label: 'french label' }
 *   }
 * })
 *
 * getCopy('label') => 'english label'
 *
 * @description The entire dictionary may be overridden by simply passing a single language object as `copy`:
 * @example
 * const getCopy = useCopy({
 *   copy: { label: 'custom label' }
 * })
 *
 * getCopy('label') => 'custom label'
 *
 * @param {object} [dictionary]
 * @param {'en'|'fr'|object} copy - language
 * @return {function(string): string}
 */
function useCopy(_ref) {
  let {
    dictionary,
    copy = DEFAULT_COPY
  } = _ref;
  if (typeof copy === 'string') {
    return key => key ? dictionary[copy][key] : dictionary[copy];
  }

  // support overriding the entire copy dictionary with an object for a single language
  return key => copy[key];
}
var _default = exports.default = useCopy;